// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NoData_wrap__1iVf7"};